// extracted by mini-css-extract-plugin
export var button = "_mr-0";